import { ScheduledAppointment } from 'src/app/shared/models/scheduled-appointment.model';
import {
  Babysitter,
  Colf,
  Nurse,
  Petsitter,
  RequestNurseDetail,
  RequestPetsitterDetail,
} from 'npx-family-happy-common';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { CaregiverSummary, Request } from 'npx-family-happy-common';
import { NutritionistRequestDetail } from '../../models/request-nutritionist-detail.model';
import { Nutritionist } from 'src/app/nutritionist';
import { Psychologist } from '../../models/psychologist.model';
import { Coach } from '../../models/coach.model';
import { CoachRequestDetail } from '../../models/request-coach-detail.model';
import { PsychologistRequestDetail } from '../../models/request-psychologist-detail.model';
import { DoctorRequestDetail } from '../../models/request-doctor-detail.model';

const DEFAULT_REQUEST_STATE = {
  route: 'request-list',
  step: 0,
  id: 'null',
  request: undefined,
  babysitterFilters: {},
  listFilters: {},
  babysitterUnwanted: [],
  timestampPreventivo: undefined,
  scheduledAppointment: undefined,
  unsavedChanges: false,
  doNotLoadFromServer: false,
  requestDetail: undefined,
  isNew: true,
};

export interface RequestState {
  route: string;
  step: number;
  id: string;
  request: Request | undefined;
  babysitterFilters: any;
  listFilters: any;
  babysitterUnwanted: CaregiverSummary[];
  timestampPreventivo: Date | undefined;
  scheduledAppointment: ScheduledAppointment | undefined;
  unsavedChanges: boolean;
  doNotLoadFromServer: boolean;
  requestDetail:
    | undefined
    | RequestPetsitterDetail
    | RequestNurseDetail
    | NutritionistRequestDetail
    | CoachRequestDetail
    | PsychologistRequestDetail
    | DoctorRequestDetail;
  isNew: boolean;
}

export interface BabysitterState {
  route: string;
  step: number;
  id: string;
  babysitter: Babysitter | undefined;
  filters: any;
}

export interface PetsitterState {
  route: string;
  step: number;
  id: string;
  petsitter: Petsitter | undefined;
  filters: any;
}

export interface NurseState {
  route: string;
  step: number;
  id: string;
  nurse: Nurse | undefined;
  filters: any;
}

export interface ColfState {
  route: string;
  step: number;
  id: string;
  colf: Colf | undefined;
  filters: any;
}

export interface NutritionistState {
  route: string;
  step: number;
  id: string;
  nutritionist: Nutritionist | undefined;
  filters: any;
}
export interface PsychologistState {
  route: string;
  step: number;
  id: string;
  psychologist: Psychologist | undefined;
  filters: any;
}
export interface CoachState {
  route: string;
  step: number;
  id: string;
  coach: Coach | undefined;
  filters: any;
}

@Injectable({
  providedIn: 'root',
})
export class RouterStateManagerService {
  private requestState = new BehaviorSubject<RequestState>(
    DEFAULT_REQUEST_STATE
  );
  private babysitterState = new BehaviorSubject<BabysitterState>({
    route: 'babysitter-list',
    step: 0,
    id: 'null',
    babysitter: undefined,
    filters: {},
  });
  private petsitterState = new BehaviorSubject<PetsitterState>({
    route: 'petsitter-list',
    step: 0,
    id: 'null',
    petsitter: undefined,
    filters: {},
  });
  private nurseState = new BehaviorSubject<NurseState>({
    route: 'nurse-list',
    step: 0,
    id: 'null',
    nurse: undefined,
    filters: {},
  });
  private colfState = new BehaviorSubject<ColfState>({
    route: 'colf-list',
    step: 0,
    id: 'null',
    colf: undefined,
    filters: {},
  });

  private nutritionistState = new BehaviorSubject<NutritionistState>({
    route: 'nutritionist-list',
    step: 0,
    id: 'null',
    nutritionist: undefined,
    filters: {},
  });
  private psychologistState = new BehaviorSubject<PsychologistState>({
    route: 'psychologist-list',
    step: 0,
    id: 'null',
    psychologist: undefined,
    filters: {},
  });
  private coachState = new BehaviorSubject<CoachState>({
    route: 'coach-list',
    step: 0,
    id: 'null',
    coach: undefined,
    filters: {},
  });

  constructor(private router: Router) {}

  getBabysitterState() {
    return this.babysitterState;
  }

  getPetsitterState() {
    return this.petsitterState;
  }

  getNurseState() {
    return this.nurseState;
  }

  getColfState() {
    return this.colfState;
  }

  getNutritionistState() {
    return this.nutritionistState;
  }
  getPsychologistState() {
    return this.psychologistState;
  }
  getCoachState() {
    return this.coachState;
  }

  getRequestState() {
    return this.requestState;
  }

  setPetsitterState(state: PetsitterState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.petsitterState.next(state);
  }

  setNurseState(state: NurseState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.nurseState.next(state);
  }

  setColfState(state: ColfState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.colfState.next(state);
  }

  setNutritionistState(state: NutritionistState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.nutritionistState.next(state);
  }
  setPsychologistState(state: PsychologistState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.psychologistState.next(state);
  }
  setCoachState(state: CoachState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.coachState.next(state);
  }

  setBabysitterState(state: BabysitterState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.babysitterState.next(state);
  }

  setRequestState(state: RequestState, navigate = true) {
    if (navigate) {
      this.router.navigate([state.route]);
    }
    this.requestState.next(state);
  }

  setBabysitter(babysitter: Babysitter) {
    const state = this.babysitterState.getValue();
    state.babysitter = babysitter;
    this.setBabysitterState(state);
  }

  setPetsitter(petsitter: Petsitter) {
    const state = this.petsitterState.getValue();
    state.petsitter = petsitter;
    this.setPetsitterState(state);
  }

  setNurse(nurse: Nurse) {
    const state = this.nurseState.getValue();
    state.nurse = nurse;
    this.setNurseState(state);
  }

  setColf(colf: Colf) {
    const state = this.colfState.getValue();
    state.colf = colf;
    this.setColfState(state);
  }

  setNutritionist(nutritionist: Nutritionist) {
    const state = this.nutritionistState.getValue();
    state.nutritionist = nutritionist;
    this.setNutritionistState(state);
  }
  setPsychologist(psychologist: Psychologist) {
    const state = this.psychologistState.getValue();
    state.psychologist = psychologist;
    this.setPsychologistState(state);
  }
  setCoach(coach: Coach) {
    const state = this.coachState.getValue();
    state.coach = coach;
    this.setCoachState(state);
  }

  setRequest(request: Request, doNotLoadFromServer = false) {
    const state = this.requestState.getValue();
    state.doNotLoadFromServer = doNotLoadFromServer;
    state.request = request;
    this.setRequestState(state);
  }

  setScheduledAppointment(scheduledAppointment: ScheduledAppointment) {
    const state = this.requestState.getValue();
    state.scheduledAppointment = scheduledAppointment;
    this.setRequestState(state);
  }

  setRequestDetail(
    requestDetail:
      | RequestPetsitterDetail
      | RequestNurseDetail
      | NutritionistRequestDetail
      | CoachRequestDetail
      | PsychologistRequestDetail
      | DoctorRequestDetail
  ) {
    const state = this.requestState.getValue();
    state.requestDetail = requestDetail;
    this.setRequestState(state);
  }

  resetRequestState() {
    this.requestState.next(DEFAULT_REQUEST_STATE);
  }
}
